(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1389,8566],{

/***/ 19148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function CustomHead(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [title, " | ", "SUPERMARKET Κρητικός"]
    }), children]
  });
}

/***/ }),

/***/ 98924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GQ": function() { return /* binding */ SMART; },
/* harmony export */   "JD": function() { return /* binding */ USER_PROFILE; },
/* harmony export */   "aA": function() { return /* binding */ CATEGORIES; },
/* harmony export */   "jn": function() { return /* binding */ OFFERS; },
/* harmony export */   "ve": function() { return /* binding */ HOMEPAGE; }
/* harmony export */ });
/* unused harmony export ORDER_HISTORY */
var HOMEPAGE = '/';
var USER_PROFILE = '/user';
var ORDER_HISTORY = '/useσr/history';
var OFFERS = '/offers';
var CATEGORIES = '/categories';
var SMART = '/smart';

/***/ }),

/***/ 30344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Favorites; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/CustomHead.jsx
var CustomHead = __webpack_require__(19148);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(98924);
// EXTERNAL MODULE: ./src/utils/analytics.js
var analytics = __webpack_require__(99700);
// EXTERNAL MODULE: ./src/components/ProductsMenu/ProductListItem.jsx + 1 modules
var ProductListItem = __webpack_require__(57730);
// EXTERNAL MODULE: ./src/components/FavoriteProducts/FavoriteProducts.module.scss
var FavoriteProducts_module = __webpack_require__(45569);
var FavoriteProducts_module_default = /*#__PURE__*/__webpack_require__.n(FavoriteProducts_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/FavoriteProducts/FavoriteProducts.jsx









function FavoriteProducts(_ref) {
  var productsShowing = _ref.productsShowing,
      categoriesShowing = _ref.categoriesShowing,
      quantitiesOfProducts = _ref.quantitiesOfProducts,
      loading = _ref.loading;
  (0,react.useEffect)(function () {
    if (productsShowing.length > 0) {
      (0,analytics/* viewItemList */.hW)((0,analytics/* getProductsCartInfo */.ez)(productsShowing.flat()), {
        item_list_id: 'Favorites',
        item_list_name: 'Αγαπημένα'
      });
    }
  }, [JSON.stringify(productsShowing)]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (FavoriteProducts_module_default()).section,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: (FavoriteProducts_module_default()).header,
      children: "\u0391\u0393\u0391\u03A0\u0397\u039C\u0395\u039D\u0391 \u03A0\u03A1\u039F\u03AA\u039F\u039D\u03A4\u0391"
    }), productsShowing.length !== 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (FavoriteProducts_module_default()).text,
        children: "\u0394\u03B9\u03AC\u03BB\u03B5\u03BE\u03B5 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03B1\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03B1 \u03C3\u03BF\u03C5 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03AD\u03BE\u03C5\u03C0\u03BD\u03B5\u03C2 \u03C0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03BC\u03B1\u03C2 \u03B1\u03C0\u03CC \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03C0\u03BF\u03C5 \u03C8\u03C9\u03BD\u03AF\u03B6\u03B5\u03B9\u03C2 \u03C3\u03C5\u03C7\u03BD\u03CC\u03C4\u03B5\u03C1\u03B1!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (FavoriteProducts_module_default()).text,
        children: " \u03A0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C3\u03AD \u03C4\u03B1 \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9 \u03B3\u03B9\u03B1 \u03B1\u03BA\u03CC\u03BC\u03B1 \u03C0\u03B9\u03BF \u03B5\u03CD\u03BA\u03BF\u03BB\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03B3\u03C1\u03AE\u03B3\u03BF\u03C1\u03B5\u03C2 \u03B1\u03B3\u03BF\u03C1\u03AD\u03C2!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: (FavoriteProducts_module_default()).listFavorites,
        children: categoriesShowing.map(function (c, index) {
          var _productsShowing$inde;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (FavoriteProducts_module_default()).listHeader,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: (FavoriteProducts_module_default()).listTitle,
                children: c.name
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (FavoriteProducts_module_default()).listContainer,
              children: (_productsShowing$inde = productsShowing[index]) === null || _productsShowing$inde === void 0 ? void 0 : _productsShowing$inde.map(function (p) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductListItem/* default */.Z, {
                  _product: p,
                  productsQuantities: quantitiesOfProducts[p._id],
                  disabled: !p.enabled || !p.available,
                  itemListId: "Favorites",
                  itemListName: "\u0391\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03B1"
                }, p._id);
              })
            })]
          }, c._id);
        })
      })]
    }), productsShowing.length === 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FavoriteProducts_module_default()).emptyStateContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (FavoriteProducts_module_default()).emptyStateIcon,
        src: "/assets/global/favorite-cart.png",
        alt: "cart with a heart"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        className: (FavoriteProducts_module_default()).emptyStateHeader,
        children: "\u0397 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BC\u03B5 \u03C4\u03B1 \u03B1\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03B1 \u03C3\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B5\u03BD\u03AE!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (FavoriteProducts_module_default()).emptyStateText,
        children: "\u03A0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C3\u03B5 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03C4\u03B1 \u03B1\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03B1 \u03C3\u03BF\u03C5 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03BA\u03B1\u03C4\u03AC\u03BB\u03BF\u03B3\u03BF \u03BA\u03B1\u03B9 \u03BE\u03B5\u03BA\u03AF\u03BD\u03B1 \u03C4\u03B9\u03C2 \u03B1\u03B3\u03BF\u03C1\u03AD\u03C2 \u03C3\u03BF\u03C5, \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03BF\u03C5 \u03BA\u03AC\u03BD\u03BF\u03C5\u03BC\u03B5 \u03AD\u03BE\u03C5\u03C0\u03BD\u03B5\u03C2 \u03C0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03BC\u03B5 \u03B2\u03AC\u03C3\u03B7 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03C0\u03BF\u03C5 \u03C8\u03C9\u03BD\u03AF\u03B6\u03B5\u03B9\u03C2 \u03C3\u03C5\u03C7\u03BD\u03CC\u03C4\u03B5\u03C1\u03B1!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (FavoriteProducts_module_default()).emptyStateText,
        children: "\u0388\u03C4\u03C3\u03B9 \u03BF\u03B9 \u03B1\u03B3\u03BF\u03C1\u03AD\u03C2 \u03C3\u03BF\u03C5 \u03B3\u03AF\u03BD\u03BF\u03BD\u03C4\u03B1\u03B9 \u03B1\u03BA\u03CC\u03BC\u03B1 \u03C0\u03B9\u03BF \u03B5\u03CD\u03BA\u03BF\u03BB\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03B3\u03C1\u03AE\u03B3\u03BF\u03C1\u03B5\u03C2!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FavoriteProducts_module_default()).linkContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: routes/* OFFERS */.jn,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (FavoriteProducts_module_default()).emptyStateLink,
            children: "\u0394\u03B5\u03C2 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1"
          })
        })
      })]
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
// EXTERNAL MODULE: ./src/store/cart.js
var cart = __webpack_require__(88362);
// EXTERNAL MODULE: ./src/store/categories.js
var categories = __webpack_require__(9266);
// EXTERNAL MODULE: ./src/store/deliveryMode.js
var deliveryMode = __webpack_require__(34525);
// EXTERNAL MODULE: ./src/store/productsCollection.js
var productsCollection = __webpack_require__(67713);
// EXTERNAL MODULE: ./src/store/user.js
var user = __webpack_require__(73471);
// EXTERNAL MODULE: ./src/utils/products.js
var products = __webpack_require__(1003);
;// CONCATENATED MODULE: ./src/pages/favorites.jsx






















var __N_SSG = true;
function Favorites(_ref) {
  var navigation = _ref.navigation,
      footerLinks = _ref.footerLinks,
      title = _ref.title;

  var _useState = (0,react.useState)(undefined),
      allProductsInCollections = _useState[0],
      setAllProductsInCollections = _useState[1];

  var _useState2 = (0,react.useState)([]),
      allCategories = _useState2[0],
      setAllCategories = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      categoriesShowing = _useState3[0],
      setCategoriesShowing = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      productsShowing = _useState4[0],
      setProductsShowing = _useState4[1];

  var _useState5 = (0,react.useState)(undefined),
      quantitiesOfProducts = _useState5[0],
      setQuantitiesOfProducts = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isCartVisible = _useState6[0],
      setIsCartVisible = _useState6[1];

  var _useState7 = (0,react.useState)(true),
      loading = _useState7[0],
      setLoading = _useState7[1];

  (0,react.useEffect)(function () {
    var productsCollection$ = productsCollection/* default.subscribe */.Z.subscribe(setAllProductsInCollections);
    var categories$ = categories/* default.subscribe */.Z.subscribe(setAllCategories);
    var productsQuantities$ = cart/* productsQuantities.subscribe */.UU.subscribe(function (_products) {
      setQuantitiesOfProducts(_products);
    });
    var isCartVisible$ = cart/* default.getIsVisble$ */.ZP.getIsVisble$().subscribe(setIsCartVisible);
    return function () {
      categories$.unsubscribe();
      isCartVisible$.unsubscribe();
      productsCollection$.unsubscribe();
      productsQuantities$.unsubscribe();
    };
  }, []);

  function getProducts(list) {
    var service = deliveryMode/* default.getValue */.Z.getValue();
    var collectionType = deliveryMode/* default.getCollectionAsNumber */.Z.getCollectionAsNumber(service);

    var _allProductsIncollections = productsCollection/* default.getProductsForCollections */.Z.getProductsForCollections(collectionType);

    return list.map(function (p) {
      return _allProductsIncollections.find(function (prod) {
        return p.sku === prod.sku;
      });
    });
  }

  function getList(data, type) {
    var dataByType = data.find(function (storedData) {
      return storedData.type === type;
    });
    return (dataByType === null || dataByType === void 0 ? void 0 : dataByType.products) || [];
  }

  (0,react.useEffect)(function () {
    if (isEmpty_default()(allProductsInCollections) || isEmpty_default()(allCategories)) return;
    var userLists$ = user/* default.getLists */.Z.getLists().subscribe(function (userLists) {
      var favoritesData = getList(userLists, 'favorites');
      var suggestedData = getList(userLists, 'suggested');
      var favoritesList = getProducts(favoritesData);
      var suggestedList = getProducts(suggestedData);
      var favoritedSuggestedProducts = [].concat((0,toConsumableArray/* default */.Z)(favoritesList), (0,toConsumableArray/* default */.Z)(suggestedList)).filter(function (p) {
        return p;
      });

      var _splitProductsIntoCat = (0,products/* splitProductsIntoCategories */.T0)(favoritedSuggestedProducts, allCategories),
          _splitProductsIntoCat2 = (0,slicedToArray/* default */.Z)(_splitProductsIntoCat, 2),
          productsOrderSorted = _splitProductsIntoCat2[0],
          categoriesArrayFiltered = _splitProductsIntoCat2[1];

      var productsOrderFiltered = productsOrderSorted.map(function (_products) {
        return (// eslint-disable-next-line implicit-arrow-linebreak
          _products === null || _products === void 0 ? void 0 : _products.filter(function (value, index, self) {
            var _self$map;

            return (self === null || self === void 0 ? void 0 : (_self$map = self.map(function (p) {
              return p._id;
            })) === null || _self$map === void 0 ? void 0 : _self$map.indexOf(value._id)) === index;
          })
        );
      });
      setCategoriesShowing(categoriesArrayFiltered);
      setProductsShowing(productsOrderFiltered);
      setLoading(false);
    });
    return function () {
      userLists$.unsubscribe();
    };
  }, [allProductsInCollections, allCategories]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomHead/* default */.Z, {
      title: title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      className: (index_module_default()).headerContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        navigation: navigation
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((0,defineProperty/* default */.Z)({}, (FavoriteProducts_module_default()).spaceOpenCart, isCartVisible)),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FavoriteProducts, {
        categoriesShowing: categoriesShowing,
        productsShowing: productsShowing,
        quantitiesOfProducts: quantitiesOfProducts,
        loading: loading
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 58345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eH": function() { return /* binding */ CalledProductCategories; },
/* harmony export */   "nv": function() { return /* binding */ ActiveProduct; },
/* harmony export */   "r1": function() { return /* binding */ CalledSuperProductCategories; },
/* harmony export */   "vX": function() { return /* binding */ RenderedProducts; }
/* harmony export */ });
/* unused harmony export ProductsStore */
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20090);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70051);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55709);
/* harmony import */ var _api_Products__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16562);





var FETCH_STATUSES = {
  UNFETCHED: 'UNFETCHED',
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED'
};
var subjectProducts = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X([]);
var statusSub = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(FETCH_STATUSES.UNFETCHED);
var activeProduct = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X('');
var renderedProduct = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X({});
var calledProductCategories = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(1);
var calledSuperProductCategories = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(1);
var ActiveProduct = {
  update: function update(id) {
    activeProduct.next(id);
  },
  subscribe: function subscribe(setState) {
    return activeProduct.subscribe(setState);
  },
  getValue: function getValue() {
    return activeProduct.value;
  }
};
var CalledProductCategories = {
  update: function update(id) {
    calledProductCategories.next(id);
  },
  subscribe: function subscribe(setState) {
    return calledProductCategories.subscribe(setState);
  },
  getValue: function getValue() {
    return calledProductCategories.value;
  }
};
var CalledSuperProductCategories = {
  update: function update(id) {
    calledSuperProductCategories.next(id);
  },
  subscribe: function subscribe(setState) {
    return calledSuperProductCategories.subscribe(setState);
  },
  getValue: function getValue() {
    return calledSuperProductCategories.value;
  }
};
var RenderedProducts = {
  update: function update(products) {
    renderedProduct.next(products);
  },
  subscribe: function subscribe(setState) {
    return renderedProduct.subscribe(setState);
  },
  getValue: function getValue() {
    return renderedProduct.value;
  }
};
var ProductsStore = {
  update: function update(products) {
    statusSub.next(FETCH_STATUSES.FETCHED);
    subjectProducts.next(products);
    return products;
  },
  subscribe: function subscribe(setState) {
    return subjectProducts.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectProducts.value;
  },

  /**
   * If fetching, return when response is ready
   * If fetched, return data from the memory
   * If fetched or (fetched & force update)
   * requests data from server
   * @param {Boolean} forceUpdate
   * @returns products
   */
  getOrFetch: function getOrFetch() {
    var _arguments = arguments;
    return (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var forceUpdate, products;
      return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              forceUpdate = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;

              if (!(statusSub.getValue() === FETCH_STATUSES.FETCHING)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", statusSub.pipe((0,rxjs_operators__WEBPACK_IMPORTED_MODULE_4__/* .skipUntil */ .u)(function (v) {
                return v === FETCH_STATUSES.FETCHED;
              }), (0,rxjs_operators__WEBPACK_IMPORTED_MODULE_5__/* .map */ .U)(function () {
                return subjectProducts.getValue();
              })).toPromise());

            case 3:
              if (!(!forceUpdate && statusSub.getValue() === FETCH_STATUSES.FETCHED)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", ProductsStore.getValue());

            case 5:
              statusSub.next(FETCH_STATUSES.FETCHING);
              _context.next = 8;
              return (0,_api_Products__WEBPACK_IMPORTED_MODULE_1__/* .getProductsWithDetails */ .Hf)();

            case 8:
              products = _context.sent;
              return _context.abrupt("return", ProductsStore.update(products.products));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  ProductsStore: ProductsStore
});

/***/ }),

/***/ 40308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favorites",
      function () {
        return __webpack_require__(30344);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45569:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"FavoriteProducts_section__R9b_S","container":"FavoriteProducts_container__WYz7k","header":"FavoriteProducts_header__ZK_4O","text":"FavoriteProducts_text__8R5ep","listContainer":"FavoriteProducts_listContainer__0orMl","listBanner":"FavoriteProducts_listBanner__fU0qR","listFavorites":"FavoriteProducts_listFavorites__yHwIF","listTitle":"FavoriteProducts_listTitle__PmxEM","listHeader":"FavoriteProducts_listHeader__DA5HJ","spaceOpenCart":"FavoriteProducts_spaceOpenCart__XFjd_","emptyStateContainer":"FavoriteProducts_emptyStateContainer__4TTu6","emptyStateIcon":"FavoriteProducts_emptyStateIcon___3XqQ","emptyStateHeader":"FavoriteProducts_emptyStateHeader__6_HO4","emptyStateText":"FavoriteProducts_emptyStateText__5qrr6","emptyStateLink":"FavoriteProducts_emptyStateLink__bQCqZ"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; },
/* harmony export */   "df": function() { return /* binding */ InView; }
/* harmony export */ });
/* unused harmony exports default, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }

  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }

  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

var _excluded = ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay,
        fallbackInView = _this$props.fallbackInView;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView,
      fallbackInView = _ref.fallbackInView;

  var unobserve = react__WEBPACK_IMPORTED_MODULE_0__.useRef();

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 70051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ skipUntil; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17604);
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function skipUntil(notifier) {
    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
}
var SkipUntilOperator = /*@__PURE__*/ (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (destination, source) {
        return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
    };
    return SkipUntilOperator;
}());
var SkipUntilSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        var _this = _super.call(this, destination) || this;
        _this.hasValue = false;
        var innerSubscriber = new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__/* .SimpleInnerSubscriber */ .IY(_this);
        _this.add(innerSubscriber);
        _this.innerSubscription = innerSubscriber;
        var innerSubscription = (0,_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__/* .innerSubscribe */ .ft)(notifier, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            _this.add(innerSubscription);
            _this.innerSubscription = innerSubscription;
        }
        return _this;
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function () {
        this.hasValue = true;
        if (this.innerSubscription) {
            this.innerSubscription.unsubscribe();
        }
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
    };
    return SkipUntilSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__/* .SimpleOuterSubscriber */ .Ds));
//# sourceMappingURL=skipUntil.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,260,2013,3253,3996,4843,9950,7730,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(40308); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);